'use client';
import { Insights } from '@mui/icons-material';
import { Button, type ButtonProps, Typography } from '@mui/material';
import { useCourses } from '@/providers';
import { useViewStore } from '@/stores';

export default function ButtonRequestTestSubmission({
  size = 'medium',
}: {
  size?: ButtonProps['size'];
}) {
  const { courseStatus } = useCourses();
  const { toggleDialog } = useViewStore();

  const onRequestTestSubmission = () => {
    const remaining = courseStatus?.repetitions?.remaining ?? 0;
    let text =
      'Du kannst den Vorgang nicht rückgängig machen und die Übungen und Fragen danach nicht mehr bearbeiten. Dir verbleiben nach der Auswertung ';
    if (remaining === 0) {
      text += 'keine weiteren Testruns.';
    } else if (remaining > 0) {
      text += `noch ${remaining} weitere Testruns.`;
    }
    text += ' Du kannst weitere Testruns erwerben.';
    const content = <Typography>{text}</Typography>;
    toggleDialog({
      action: 'submitTest',
      actionLabel: 'Test auswerten',
      content,
      title: 'Möchtest Du den Test mit allen Fragen final auswerten?',
    });
  };

  return (
    <Button
      variant="contained"
      startIcon={<Insights />}
      onClick={() => onRequestTestSubmission()}
      size={size}>
      Test auswerten
    </Button>
  );
}
